// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';
import Select from 'sail/Select';

import {useData} from 'docs/data/integration-builder';
import {DEFAULT_APPEARANCE_COLORS} from 'docs/util';

import {ColorPicker} from './ColorPicker';

const messages = defineMessages({
  theme: {
    id: 'docsApp.integrationBuilder.demo.appearancePicker.theme',
    description: 'Label for appearance theme selector',
    defaultMessage: 'Theme',
  },
  primaryColor: {
    id: 'docsApp.integrationBuilder.demo.appearancePicker.primaryColor',
    description: 'Label for primary color selector',
    defaultMessage: 'Primary color',
  },
  backgroundColor: {
    id: 'docsApp.integrationBuilder.demo.appearancePicker.backgroundColor',
    description: 'Label for background color selector',
    defaultMessage: 'Background color',
  },
  textColor: {
    id: 'docsApp.integrationBuilder.demo.appearancePicker.textColor',
    description: 'Label for text color selector',
    defaultMessage: 'Text color',
  },
});

const THEME_OPTIONS = [
  {
    value: 'stripe',
    label: 'stripe',
  },
  {
    value: 'night',
    label: 'night',
  },
  {
    value: 'flat',
    label: 'flat',
  },
];

export const AppearancePicker = () => {
  const {appearance, setAppearance} = useData();

  const updateAppearance = (
    key: 'primaryColor' | 'backgroundColor' | 'textColor',
    val,
  ) => {
    if (key === 'primaryColor') {
      setAppearance({...appearance, primaryColor: val});
    } else if (key === 'backgroundColor') {
      setAppearance({...appearance, backgroundColor: val});
    } else if (key === 'textColor') {
      setAppearance({...appearance, textColor: val});
    }
  };

  return (
    <Box
      flex={{direction: 'column', justifyContent: 'center'}}
      padding={{top: 8}}
      className="AppearancePicker"
    >
      <Box flex={{alignItems: 'center'}} margin={{top: 12}}>
        <BodyAlt style={{width: 100, marginRight: 16}}>
          <FormattedMessage {...messages.theme} />
        </BodyAlt>
        <Select
          options={THEME_OPTIONS}
          onChange={(theme) =>
            setAppearance({
              theme,
              ...DEFAULT_APPEARANCE_COLORS[theme],
            })
          }
          value={appearance.theme}
          sortOptions={false}
        />
      </Box>
      <Box flex={{alignItems: 'center'}} margin={{top: 12}}>
        <BodyAlt style={{width: 100, marginRight: 16}}>
          <FormattedMessage {...messages.primaryColor} />
        </BodyAlt>
        <ColorPicker
          value={appearance.primaryColor}
          onBlur={(color) => {
            updateAppearance('primaryColor', color);
          }}
        />
      </Box>
      <Box flex={{alignItems: 'center'}} margin={{top: 12}}>
        <BodyAlt style={{width: 100, marginRight: 16}}>
          <FormattedMessage {...messages.backgroundColor} />
        </BodyAlt>
        <ColorPicker
          value={appearance.backgroundColor}
          onBlur={(color) => {
            updateAppearance('backgroundColor', color);
          }}
        />
      </Box>
      <Box flex={{alignItems: 'center'}} margin={{top: 12}}>
        <BodyAlt style={{width: 100, marginRight: 16}}>
          <FormattedMessage {...messages.textColor} />
        </BodyAlt>
        <ColorPicker
          value={appearance.textColor}
          onBlur={(color) => {
            updateAppearance('textColor', color);
          }}
        />
      </Box>
    </Box>
  );
};
